import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../utils/analytics';
import { getPageTitle } from '../utils/pageTitles';
import { useCookieConsent } from '../context/useCookieConsent';

/**
 * Loads GA4/Plausible after cookie consent, then tracks page views on load and route change.
 * Page views must run here (not in ScrollToTop) so gtag is initialized before the first hit.
 */
export default function AnalyticsLoader() {
  const { hasAnalyticsConsent } = useCookieConsent();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!hasAnalyticsConsent) return;
    initAnalytics();
    trackPageView(pathname, getPageTitle(pathname));
  }, [hasAnalyticsConsent, pathname]);

  return null;
}
